import React from 'react';

/**
 * The Business Cases the user takes part in, each with how many of their
 * services it grants. Names come as "EPÜ — Intelligent facility …": the part
 * before the dash is shown as the title, the rest as its description.
 */
export const BusinessCaseList = ({ businessCases, services }) => (
  <ul className="list-none m-0 p-0 grid grid-cols-1 md:grid-cols-2 gap-3">
    {businessCases.map((bc) => {
      const [short, ...rest] = String(bc.name || bc.code).split(' — ');
      const count = services.filter((s) => (s.access?.businessCases || []).includes(bc.code)).length;
      return (
        <li key={bc.code} className="card-base px-4 py-3 flex items-start gap-3">
          <span className="text-[11px] font-semibold px-1.5 py-[2px] rounded-[4px] bg-black/[0.05] text-lb-ink mt-0.5">
            {bc.code}
          </span>
          <span className="flex-1 min-w-0">
            <span className="block text-[13px] font-semibold text-lb-ink-strong">{short}</span>
            {rest.length > 0 && (
              <span className="block text-[12px] text-lb-muted leading-[1.45]">{rest.join(' — ')}</span>
            )}
          </span>
          <span className="text-[12px] text-lb-muted whitespace-nowrap">
            {count} {count === 1 ? 'service' : 'services'}
          </span>
        </li>
      );
    })}
  </ul>
);
